import React from "react";
import { StepProgress } from './StepProgress';
import { ImportContactsModalStep } from "./ImportContactsModalStep";

type StepIndicatorProps = {
  currentStep: ImportContactsModalStep;
  onBack?: () => void;
};

const steps = [
  { key: ImportContactsModalStep.upload, label: "Upload" },
  { key: ImportContactsModalStep.mapping, label: "Map" },
  { key: ImportContactsModalStep.review, label: "Review" },
  { key: ImportContactsModalStep.addToGroups, label: "Add to Groups" },
];

export default function StepIndicator({ currentStep }: StepIndicatorProps) {
  return (
    <StepProgress
      steps={steps.map(step => step.label)}
      activeIndex={steps.findIndex(step => step.key === currentStep)}
      sx={{ mb: 3 }}
    />
  );
}
